module.exports = __webpack_public_path__ + "static/media/Schools.0d588db4.png";